import { CwtApiEntity, CwtCrudContract, CwtModel, CwtProp } from "@cawita/core-front/api";
import { Address } from "../common";
import { Client } from "./client.model";
import { UnitSystem } from "../common/unit-system.model";
import { formatInTimeZone } from "date-fns-tz";

@CwtModel({ name: 'site' })
@CwtCrudContract({ path: 'site', searchMapper: (s) => ({ name: { regexp: s } }) })
@CwtCrudContract({ path: 'for-manager/client/:clientId/site', identifier: 'for-manager', searchMapper: (s) => ({ name: { regexp: s } }), })
export class Site extends CwtApiEntity {
    @CwtProp({ ref: Client }) client: Client;
    @CwtProp() name: string;
    @CwtProp() phone: string;
    @CwtProp() email: string;
    @CwtProp() timezone: string;
    @CwtProp({ ref: Address }) address: Address;
    @CwtProp() defaultWeightSystem: UnitSystem;
    @CwtProp() defaultHeightSystem: UnitSystem;

    public formatDate(date: Date, format: string) {
        if(!date) return '';
        return formatInTimeZone(date, this.timezone ?? 'Europe/Paris', format);
    }
}